const greetingTextMobile = {
    en: `Hi there! I'm Max! Wanna be best friends and play?`,
    nl: `Hallo! Ik ben Max! Laten we beste vrienden worden en spelen! Laten we een spelletje gaan spelen! Of als je liever een verhaaltje wil horen, laat het me weten!`
  };
  
  export default greetingTextMobile;
  